import { panelRouteMap } from 'app/router/config';
import i18n from '@shared/i18n';
import { PERMISSION_KEY } from './constants';

const PERMISSION_PAGE_MAP = new Map<
    string,
    {
        regex: RegExp;
        permissionKey: PERMISSION_KEY;
        name: string;
    }
>();

const pageValueMap = {
    editor: {
        regex: /^\/panel\/editor\/?/,
        name: i18n.gettext('商店編輯器'),
        permissionKey: PERMISSION_KEY.EDITOR,
    },
    navigation: {
        regex: /^\/panel\/settings\/navigation\/?/,
        name: i18n.gettext('商店導覽選單設定'),
        permissionKey: PERMISSION_KEY.EDITOR,
    },
    order: {
        regex: /^\/panel\/order\/?/,
        name: i18n.gettext('訂單管理'),
        permissionKey: PERMISSION_KEY.ORDER_MANAGEMENT,
    },
    product: {
        regex: /^\/panel\/product\/?/,
        name: i18n.gettext('商品管理'),
        permissionKey: PERMISSION_KEY.PRODUCT_MANAGEMENT,
    },
    member: {
        regex: /^\/panel\/member\/?/,
        name: i18n.gettext('會員管理'),
        permissionKey: PERMISSION_KEY.MEMBER_MANAGEMENT,
    },
    promotions: {
        regex: /^\/panel\/promotions\/?/,
        name: i18n.gettext('優惠模組'),
        permissionKey: PERMISSION_KEY.PROMO_MANAGEMENT,
    },
    shipping: {
        regex: /^\/panel\/settings\/shipping\/?/,
        name: i18n.gettext('物流設定'),
        permissionKey: PERMISSION_KEY.SHIPPING_MANAGEMENT,
    },
    revenue: {
        regex: /^\/panel\/revenue\/?/,
        name: i18n.gettext('營收報表'),
        permissionKey: PERMISSION_KEY.FINANCE_MANAGEMENT,
    },
    finance: {
        regex: /^\/panel\/settings\/finance\/?/,
        name: i18n.gettext('帳務管理'),
        permissionKey: PERMISSION_KEY.FINANCE_MANAGEMENT,
    },
    permission: {
        regex: /^\/panel\/settings\/permission\/?/,
        name: i18n.gettext('權限管理'),
        permissionKey: PERMISSION_KEY.BRAND_SUPER_ADMIN,
    },
    basic: {
        regex: /^\/panel\/settings\/basic\/?/,
        name: i18n.gettext('商店基礎設定'),
        permissionKey: PERMISSION_KEY.BRAND_SUPER_ADMIN,
    },
    payment: {
        regex: /^\/panel\/subscribe\/payment\/?/,
        name: i18n.gettext('帳單與付款資訊'),
        permissionKey: PERMISSION_KEY.BRAND_SUPER_ADMIN,
    },
    plan: {
        regex: /^\/panel\/subscribe\/plan\/?/,
        name: i18n.gettext('訂閱方案'),
        permissionKey: PERMISSION_KEY.BRAND_SUPER_ADMIN,
    },
};

PERMISSION_PAGE_MAP.set(panelRouteMap.editor.routeName, pageValueMap.editor);

PERMISSION_PAGE_MAP.set(panelRouteMap.order.routeName, pageValueMap.order);

panelRouteMap.product.routes.forEach((route) => {
    PERMISSION_PAGE_MAP.set(route.routeName, pageValueMap.product);
});

PERMISSION_PAGE_MAP.set(panelRouteMap.member.routeName, {
    regex: /^\/panel\/member\/?$/,
    name: i18n.gettext('會員管理'),
    permissionKey: PERMISSION_KEY.MEMBER_MANAGEMENT,
});

panelRouteMap.promotions.routes.forEach((route) => {
    PERMISSION_PAGE_MAP.set(route.routeName, pageValueMap.promotions);
});

PERMISSION_PAGE_MAP.set('permission', pageValueMap.permission);

PERMISSION_PAGE_MAP.set('shipping', pageValueMap.shipping);

PERMISSION_PAGE_MAP.set(panelRouteMap.revenue.routeName, pageValueMap.revenue);

PERMISSION_PAGE_MAP.set('finance', pageValueMap.finance);

PERMISSION_PAGE_MAP.set('basic', pageValueMap.basic);

PERMISSION_PAGE_MAP.set('navigation', pageValueMap.navigation);

PERMISSION_PAGE_MAP.set('payment', pageValueMap.payment);

PERMISSION_PAGE_MAP.set('plan', pageValueMap.plan);

function allowUserAccess(routeName: string, profile: Profile) {
    // super admin 有所有頁面權限
    if (profile.permissions.includes(PERMISSION_KEY.BRAND_SUPER_ADMIN)) {
        return true;
    }

    const permissionPage = PERMISSION_PAGE_MAP.get(routeName);

    // 未定義的頁面，直接可以訪問
    // 有定義的頁面，需要檢查權限
    if (!permissionPage || profile.permissions.includes(permissionPage.permissionKey)) {
        return true;
    }

    return permissionPage;
}

export { PERMISSION_PAGE_MAP, allowUserAccess, pageValueMap };
